import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ServiceStatus } from "@/models/enums/service";
import { mergeObjects } from "@/utils/utils";
import { CallToActionService } from "@/services/plan/visit/call_to_action";
import { CallToActionDataModel } from "@/models/classes/plan/visit/call_to_action";

const service = new CallToActionService();

interface CallToActionState {
  callToAction: {
    network: {
      code: ServiceStatus;
      error?: string;
    };
    data?: CallToActionDataModel;
    total: number;
  };
}

const initialState: CallToActionState = {
  callToAction: {
    network: {
      code: ServiceStatus.idle,
      error: undefined,
    },
    data: undefined,
    total: 0,
  },
};

export const slice = createSlice({
  name: "CallToAction",
  initialState,
  reducers: {
    reset: () => initialState,
    patch: (state, action) => mergeObjects({ ...state }, action.payload),
  },
  extraReducers: (builder) => {
    builder.addCase(onFetchGetCallToAction.pending, (state) => {
      state.callToAction.network.code = ServiceStatus.loading;
    });
    builder.addCase(onFetchGetCallToAction.fulfilled, (state, action) => {
      state.callToAction.network.code = ServiceStatus.succeeded;
      if (action.payload != null && action.payload.data) {
        state.callToAction.data = action.payload.data;
        state.callToAction.total = action.payload.total;
      } else {
        state.callToAction.data = undefined;
        state.callToAction.total = 0;
      }
    });
    builder.addCase(onFetchGetCallToAction.rejected, (state, action) => {
      state.callToAction.network.code = ServiceStatus.failed;
      state.callToAction.network.error =
        (action.payload as string) || "Failed to fetch data";
    });
  },
});

export const onFetchGetCallToAction = createAsyncThunk(
  "plan/call_to_action",
  async (
    params: {
      customerCode: string;
      activityDate?: string;
      saleOrgCriteriaId?: number | string | null;
    },
    thunkAPI,
  ) => {
    try {
      const apiData = await service.fetchGetCallToAction(params);
      return apiData;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Error",
      );
    }
  },
);

export const onFetchGetStockByCustomer = createAsyncThunk(
  "plan/call_to_action_stock",
  async (params: any, thunkAPI) => {
    try {
      const apiData = await service.fetchGetStockByCustomer(params);
      return apiData;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Error",
      );
    }
  },
);

export const onSaveCallToActionSuccess = createAsyncThunk(
  "plan/call_to_action_save",
  async (data: any, thunkAPI) => {
    try {
      const apiData = await service.saveCallToActionSuccess(data);
      return apiData;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Error",
      );
    }
  },
);

export const { reset, patch } = slice.actions;
export default slice.reducer;
